// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const AutoModeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-top: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };
`;

export const BinFeederContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  border-radius: 4px;
  flex-direction: column;
  display: flex;
  height: 100%;
`;

export const ThermometerContainer = styled.div`
  padding: 0 0.5rem;
  align-items: center;
  display: flex;
  justify-content: center;
  flex: 1;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0 0.75rem;
  };
`;
